import styled from 'styled-components';

const Content = styled.div`
	overflow: hidden;
	height: 100%;
`;

const Wrapper = styled.div`
	position: relative;
	max-height: 500px;
	background-color: ${p => p.theme.colors.white};
	height: 100%;
	width: 100%;
	overflow: auto;

	&::-webkit-scrollbar {
		width: 4px;
		height: 4px;
	}

	&::-webkit-scrollbar-thumb {
		background-color: ${p => p.theme.colors.scrollbarColor};
	}
	&:hover {
		&::-webkit-scrollbar-thumb {
			background-color: ${p => p.theme.colors.scrollbarColor};
			transition: background-color 0.5s;
		}
	}
`;

const Row = styled.tr`
	height: 52px;
	border-bottom: 1px solid #e6e6e6;

	&:last-child {
		border-bottom: none;
	}
`;

const exportedObject = { Content, Wrapper, Row };

export default exportedObject;
